<template>
  <div class="main" v-if="isShowContent">
    <HeaderBlock></HeaderBlock>
    <div class="container-fluid h-100">
      <div class="row main-row" :class="{'sidebar-hidden' : sidebarHidden}">
        <div class="col sidebar bg-dark p-0" v-show="!sidebarHidden">
          <SideBar></SideBar>
        </div>
        <div class="col">
          <div class="main-content p-3 m-2 rounded">
            <notifications></notifications>
            <v-dialog />
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBlock from '../../components/admin/HeaderBlock.vue'
import SideBar from '../../components/admin/SideBar.vue'
import { mapActions } from 'vuex'

export default {
  name: 'HomeIndex',
  components: {
    HeaderBlock,
    SideBar
  },
  async created () {
    await this.getUserInfo()
  },
  computed: {
    sidebarHidden () {
      return this.$store.state.appSettings.sidebarHidden
    },
    isShowContent () {
      return !!this.$store.state.userInfo
    }
  },
  methods: {
    ...mapActions({
      getUserInfo: 'GET_USER_INFO'
    })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'Администрирование')
    })
  }
}

</script>
